import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClToggleSwitch } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';

@Component({
    selector: 'app-form-switch',
    templateUrl: './form-switch.component.html',
    styleUrls: ['./form-switch.component.css'],
    imports: [ReactiveFormsModule, ClToggleSwitch, ErrorComponent],
})
export class FormSwitchComponent {
    readonly control = input.required<FormControl<boolean>>();
    readonly label = input.required<string>();
    readonly inputId = input.required<string>();
}
